import { Component, Input, OnChanges, OnDestroy } from '@angular/core';
import {LatLngPipe} from '../../../formatting/latLng.pipe';
import {Observation} from '../../../models/observation';
import {Router, RouterLink } from '@angular/router';
import {ToastService} from '../../../services/toast.service';
import {MainRoute, RootRoute} from '../../../models/angular-routing';
import { ShiftsManagerService } from '../../../../data/shifts/shifts-manager.service';
import { Subscription } from 'rxjs';
import { InsightsRoute } from '../../../../pages/insights/insights.routes';
import { RetryingImageViewerComponent } from '../retrying-image-viewer/retrying-image-viewer.component';
import { DatePipe, UpperCasePipe } from '@angular/common';
import { LatLngModel } from '../../../models/lat.lng.model';


@Component({
  selector: 'app-observation-info-window-content',
  templateUrl: './observation-info-window-content.component.html',
  styleUrls: ['./observation-info-window-content.component.scss'],
  imports: [RetryingImageViewerComponent, RouterLink, UpperCasePipe, DatePipe, LatLngPipe],
  providers: [LatLngPipe],
})
export class ObservationInfoWindowContentComponent implements OnChanges, OnDestroy {
  @Input()
  observation: Observation;

  @Input()
  isLiveMap: boolean;

  isActiveShift = false;

  readonly RootRoute = RootRoute;
  readonly MainRoute = MainRoute;
  readonly InsightsRoute = InsightsRoute;

  private activeShiftsSubscription: Subscription;

  constructor(
    private toast: ToastService,
    private router: Router,
    private latLngPipe: LatLngPipe,
    private shiftManager: ShiftsManagerService
  ) {}

  ngOnChanges() {
    this.activeShiftsSubscription = this.shiftManager.activeShifts$.subscribe(shiftUpdates => {
      this.isActiveShift = !!shiftUpdates.state.find(shift => shift.id === this.observation?.shiftId);
    });
  }

  ngOnDestroy() {
    this.activeShiftsSubscription?.unsubscribe();
  }

  handleLocationClick(event) {
    event.stopPropagation();

    const locationText = this.latLngPipe.transform(
      new LatLngModel(this.observation.location.latitude, this.observation.location.longitude)
    );
    window.navigator.clipboard
      .writeText(locationText)
      .then(() => {
        this.toast.short('Location copied to clipboard.');
      })
      .catch(reason => {
        this.toast.short(`Failed to copy the location. ${reason}`);
      });
  }

  isLinkActive(url): boolean {
    return this.router.url.startsWith(url);
  }
}
